// Mock data for the photography portfolio

export const portfolioProjects = [
  {
    id: 1,
    title_de: "Hochzeit in der Toskana",
    title_ru: "Свадьба в Тоскане",
    description_de: "Eine romantische Hochzeit in den italienischen Hügeln",
    description_ru: "Романтическая свадьба на итальянских холмах",
    category: "wedding",
    featured: true,
    image: "https://images.unsplash.com/photo-1658250996054-5880bbe8a8c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1658250996054-5880bbe8a8c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1651344139792-4025fb1839d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1610680143139-8f15ac90b4ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 2,
    title_de: "Elegante Hochzeit",
    title_ru: "Элегантная свадьба",
    description_de: "Klassische Hochzeitszeremonie mit zeitlosen Momenten",
    description_ru: "Классическая свадебная церемония с вневременными моментами",
    category: "wedding",
    featured: false,
    image: "https://images.unsplash.com/photo-1651344139792-4025fb1839d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1651344139792-4025fb1839d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 3,
    title_de: "Business Portraits",
    title_ru: "Бизнес Портреты",
    description_de: "Professionelle Unternehmensportraits für Führungskräfte",
    description_ru: "Профессиональные корпоративные портреты для руководителей",
    category: "portrait",
    featured: true,
    image: "https://images.unsplash.com/photo-1620452537803-f50265d4d9aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1620452537803-f50265d4d9aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1487260211189-670c54da558d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 4,
    title_de: "Künstlerische Portraits",
    title_ru: "Художественные портреты",
    description_de: "Ausdrucksstarke Porträts mit kreativer Beleuchtung",
    description_ru: "Выразительные портреты с креативным освещением",
    category: "portrait",
    featured: false,
    image: "https://images.unsplash.com/photo-1487260211189-670c54da558d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1487260211189-670c54da558d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 5,
    title_de: "Moderne Architektur",
    title_ru: "Современная Архитектура",
    description_de: "Zeitgenössische Gebäude in minimalistischem Stil",
    description_ru: "Современные здания в минималистском стиле",
    category: "architecture",
    featured: false,
    image: "https://images.unsplash.com/photo-1498335746477-0c73d7353a07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1498335746477-0c73d7353a07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1632059368252-be6d65abc4e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 6,
    title_de: "Industriedesign",
    title_ru: "Промышленный дизайн",
    description_de: "Architektonische Details und Strukturen",
    description_ru: "Архитектурные детали и структуры",
    category: "architecture",
    featured: false,
    image: "https://images.unsplash.com/photo-1632059368252-be6d65abc4e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1632059368252-be6d65abc4e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 7,
    title_de: "Corporate Event",
    title_ru: "Корпоративное Мероприятие",
    description_de: "Dokumentation einer Firmenveranstaltung",
    description_ru: "Документация корпоративного мероприятия",
    category: "events",
    featured: false,
    image: "https://images.unsplash.com/reserve/LJIZlzHgQ7WPSh5KVTCB_Typewriter.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/reserve/LJIZlzHgQ7WPSh5KVTCB_Typewriter.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc1NzUwNzM2OHww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 8,
    title_de: "Kulturelle Veranstaltung",
    title_ru: "Культурное мероприятие",
    description_de: "Lebendige Dokumentation kultureller Events",
    description_ru: "Живая документация культурных событий",
    category: "events",
    featured: false,
    image: "https://images.unsplash.com/photo-1610680143139-8f15ac90b4ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    images: [
      "https://images.unsplash.com/photo-1610680143139-8f15ac90b4ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85"
    ]
  }
];

export const blogPosts = [
  {
    id: 1,
    title_de: "Die Kunst der Schwarz-Weiß-Fotografie",
    title_ru: "Искусство чёрно-белой фотографии",
    excerpt_de: "Warum Schwarz-Weiß-Fotografie zeitlos ist und wie sie Emotionen verstärkt...",
    excerpt_ru: "Почему чёрно-белая фотография вневременна и как она усиливает эмоции...",
    content_de: "Schwarz-Weiß-Fotografie ist mehr als nur das Fehlen von Farbe. Es ist eine Kunstform, die Emotionen verstärkt und den Betrachter dazu bringt, sich auf die wesentlichen Elemente zu konzentrieren...",
    content_ru: "Чёрно-белая фотография - это больше, чем просто отсутствие цвета. Это форма искусства, которая усиливает эмоции и заставляет зрителя сосредоточиться на основных элементах...",
    image: "https://images.unsplash.com/photo-1651344139792-4025fb1839d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    date: "2025-01-15",
    author: "FotografX"
  },
  {
    id: 2,
    title_de: "Hochzeitsfotografie-Tipps",
    title_ru: "Советы по свадебной фотографии",
    excerpt_de: "Die wichtigsten Momente einer Hochzeit einfangen - ein Leitfaden für perfekte Aufnahmen...",
    excerpt_ru: "Как запечатлеть важнейшие моменты свадьбы - руководство для идеальных снимков...",
    content_de: "Eine Hochzeit ist voller emotionaler Momente, die nur einmal stattfinden. Als Fotograf ist es meine Aufgabe, diese kostbaren Augenblicke für die Ewigkeit festzuhalten...",
    content_ru: "Свадьба полна эмоциональных моментов, которые происходят только один раз. Как фотограф, моя задача - запечатлеть эти драгоценные мгновения на всю вечность...",
    image: "https://images.unsplash.com/photo-1610680143139-8f15ac90b4ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwcGhvdG9ncmFwaHl8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzU3NTA3MzU5fDA&ixlib=rb-4.1.0&q=85",
    date: "2025-01-10",
    author: "FotografX"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Anna Schmidt",
    rating: 5,
    text_de: "Absolute Perfektion! Die Hochzeitsfotos sind atemberaubend und haben unsere Erwartungen übertroffen.",
    text_ru: "Абсолютное совершенство! Свадебные фотографии потрясающие и превзошли наши ожидания.",
    service: "wedding",
    date: "2023-12-15"
  },
  {
    id: 2,
    name: "Michael Weber",
    rating: 5,
    text_de: "Professionelle Business-Portraits, die perfekt für unsere Website sind. Sehr empfehlenswert!",
    text_ru: "Профессиональные бизнес-портреты, идеально подходящие для нашего сайта. Очень рекомендую!",
    service: "portrait",
    date: "2023-11-28"
  },
  {
    id: 3,
    name: "Sarah Müller",
    rating: 5,
    text_de: "Fantastische Architekturaufnahmen unseres neuen Bürogebäudes. Jedes Detail wurde perfekt eingefangen.",
    text_ru: "Фантастические архитектурные снимки нашего нового офисного здания. Каждая деталь была идеально запечатлена.",
    service: "architecture",
    date: "2023-11-10"
  }
];

export const services = [
  {
    id: 1,
    name_de: "Hochzeitsfotografie",
    name_ru: "Свадебная фотография",
    description_de: "Unvergessliche Momente Ihres besonderen Tages",
    description_ru: "Незабываемые моменты вашего особенного дня",
    icon: "Heart",
    price: "ab 1.500€"
  },
  {
    id: 2,
    name_de: "Portraitfotografie",
    name_ru: "Портретная фотография",
    description_de: "Ausdrucksstarke Portraits für Business und privat",
    description_ru: "Выразительные портреты для бизнеса и личного использования",
    icon: "User",
    price: "ab 200€"
  },
  {
    id: 3,
    name_de: "Architekturfotografie",
    name_ru: "Архитектурная фотография",
    description_de: "Professionelle Aufnahmen von Gebäuden und Räumen",
    description_ru: "Профессиональные снимки зданий и интерьеров",
    icon: "Building",
    price: "ab 400€"
  },
  {
    id: 4,
    name_de: "Eventfotografie",
    name_ru: "Событийная фотография",
    description_de: "Lebendige Dokumentation Ihrer Veranstaltungen",
    description_ru: "Живая документация ваших мероприятий",
    icon: "Camera",
    price: "ab 300€"
  },
  {
    id: 5,
    name_de: "Foto-Restauration & Kolorierung",
    name_ru: "Реставрация и колоризация фотографий",
    description_de: "Restaurierung alter Fotos und Umwandlung in lebendige Farbaufnahmen",
    description_ru: "Восстановление старых фотографий и превращение их в яркие цветные снимки",
    icon: "Palette",
    price: "ab 25€"
  },
  {
    id: 6,
    name_de: "KI-Virtuelle Fotosessions",
    name_ru: "Виртуальные фотосессии с ИИ",
    description_de: "Professionelle Portraits mit modernster KI-Technologie basierend auf Ihren Fotos",
    description_ru: "Профессиональные портреты с использованием передовых ИИ-технологий на основе ваших фотографий",
    icon: "Sparkles",
    price: "ab 35€"
  }
];